import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import React from "react";
import { RouteComponentProps, Switch } from "react-router-dom";

import {
  wsmDealerCustomerAddPath,
  wsmDealerCustomerListPath,
  wsmDealerCustomerPath,
  wsmDealerGroupAddPath,
  wsmDealerGroupListPath,
  wsmDealerGroupPath,
  wsmDealerSettingsPath,
} from "./urls";
import WsmDealerCustomerAssignView from "./views/WsmDealerCustomerAssign";
import WsmDealerCustomerDetailsView from "./views/WsmDealerCustomerDetails";
import WsmDealerCustomerListView from "./views/WsmDealerCustomerList";
import WsmDealerGroupCreateView from "./views/WsmDealerGroupCreate";
import WsmDealerGroupDetailsView from "./views/WsmDealerGroupDetails";
import WsmDealerGroupListView from "./views/WsmDealerGroupList";
import WsmDealerSettingsView from "./views/WsmDealerSettings";

const GroupDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <WsmDealerGroupDetailsView id={decodeURIComponent(match.params.id)} />
);
const CustomerDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <WsmDealerCustomerDetailsView id={decodeURIComponent(match.params.id)} />
);

// Settings and customers come first: both would otherwise match the group :id.
const Component = () => (
  <>
    <WindowTitle title="Dealer Pricing" />
    <Switch>
      <Route exact path={wsmDealerSettingsPath} component={WsmDealerSettingsView} />
      <Route exact path={wsmDealerCustomerAddPath} component={WsmDealerCustomerAssignView} />
      <Route exact path={wsmDealerCustomerListPath} component={WsmDealerCustomerListView} />
      <Route exact path={wsmDealerCustomerPath(":id")} component={CustomerDetails} />
      <Route exact path={wsmDealerGroupAddPath} component={WsmDealerGroupCreateView} />
      <Route exact path={wsmDealerGroupListPath} component={WsmDealerGroupListView} />
      <Route exact path={wsmDealerGroupPath(":id")} component={GroupDetails} />
    </Switch>
  </>
);

export default Component;
